import { React, useState, useContext } from 'react';
import { AppContext } from '../../../services/AppContext';
import { useTranslation } from 'react-i18next';

const InviteCustomer = ({ closeModal }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const [customerUsername, setCustomerUsername] = useState('');

    const handleInviteCustomer = async () => {
        try {
            const result = await apiClient.inviteCustomer({
                username: customerUsername,
            });

            if (result.hasErrors) {
                return;
            }

            notify(t('pages.customers.modals.invitationSent'), 'success');
            closeModal();
        } catch (error) {
            notify(error.message, 'error');
        }
    };

    const handleCancel = () => {
        closeModal(false);
        setCustomerUsername('');
    };

    const handleChange = (e) => {
        setCustomerUsername(e.target.value);
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>{t('pages.customers.modals.inviteCustomer')}</h3>
                <input
                    type="text"
                    name="username"
                    placeholder={t('pages.customers.modals.usernamePlaceholder')}
                    value={customerUsername}
                    onChange={handleChange}
                />

                <div className="container">
                    <button
                        className="mg-r-1 width-100p"
                        onClick={handleInviteCustomer}
                    >
                        {t('pages.customers.modals.sendButton')}
                    </button>
                    <button
                        className="width-100p"
                        onClick={handleCancel}
                    >
                        {t('pages.customers.modals.cancelButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InviteCustomer;